// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchFlatButton_wrapper__a0Lg0","gradient-animation":"SearchFlatButton_gradient-animation__QQIvL"};